import { defaultColorTheme } from "./defaultColorTheme";
import store from "~/src/store";

export type ColorThemeType = keyof typeof defaultColorTheme;

export const colorTheme = (item: ColorThemeType) => {
  const state = store.getState();

  let color = null;
  if (!state.main.colorTheme) {
    color = defaultColorTheme[item];
  } else {
    color = state.main.colorTheme[item];
  }

  if (!color) {
    console.error(`${item} color does not exist`);
  }
  return color || "cyan";
};
